/* eslint-disable import/no-cycle */
import React, {ReactElement} from 'react';
import {Options} from '@contentful/rich-text-react-renderer';

import NestedRichText from '@fo/designSystem/Text/RichText/RichText';
import {ContentfulContent, FormatMessageFunction} from '@fo/shared-types';
import Accordion, {AccordionStartOpen} from '@fo/designSystem/Accordion/Accordion';
import LookingForFinance, {LookingForFinanceSize} from '@fo/designSystem/LookingForFinance/LookingForFinance';
import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import getIdNameFromLabel from './getIdNameFromLabel';

interface AccordionProps {
  formatMessage: FormatMessageFunction;
  node?: {
    data?: {
      target?: {
        sys?: {
          accordion?: {
            items?: AccordionItemProps[];
          };
        };
      };
    };
  };
  options?: Options;
  nestedClass?: string;
  isSkipQuoteFormAndRedirectToTide?: boolean;
}

interface AccordionItemProps {
  label: string;
  content: ContentfulContent;
}

const getAccordion = ({
  node,
  formatMessage,
  nestedClass,
  isSkipQuoteFormAndRedirectToTide,
}: AccordionProps): ReactElement => {
  const items = node?.data?.target?.sys?.accordion?.items || [];

  const filteredItems = items.filter((entry) => {
    if (!entry) {
      return false;
    }
    const {label, content} = entry;
    if (!label || !content) {
      return false;
    }
    return true;
  });

  const accordionItems = filteredItems.map((entry: AccordionItemProps) => {
    const {label, content} = entry;
    return {
      label,
      id: getIdNameFromLabel(label),
      children: (
        <>
          <NestedRichText className={nestedClass || ''} content={content} isSkipQuoteFormAndRedirectToTide />
          <LookingForFinance
            size={LookingForFinanceSize.SM}
            title={formatMessage({id: 'phoenix.knowledge.workingCapital.callToAction.title'})}
            text={formatMessage({id: 'phoenix.knowledge.workingCapital.callToAction.copy'})}
            buttonProps={{
              buttonText: formatMessage({id: 'phoenix.knowledge.workingCapital.callToAction.button'}),
              url: getPageRoute('quoteForm.start'),
            }}
            hideCheckpoints
            isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
          />
        </>
      ),
    };
  });

  return <Accordion items={accordionItems} startOpen={AccordionStartOpen.BY_URL_HASH} data-testid="ui.accordion" />;
};

export default getAccordion;
